module.exports = __webpack_public_path__ + "static/media/transfers.f275b062.svg";